/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  ManagerLogic2,
  ManagerLogic2Interface,
} from "../../../contracts/manager/ManagerLogic2";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "earlyAccessIds",
        type: "uint256[]",
      },
    ],
    name: "BuyEarlyAccess",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "GetInvestmentReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bonus",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stfToSelf",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stfToDead",
        type: "uint256",
      },
    ],
    name: "GetReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAll",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "zbcUsdtPrice",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "zbcCost",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "investmentCredentialId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "Invest",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtToColdWallet",
        type: "uint256",
      },
    ],
    name: "RedeemUsds",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "inviter",
        type: "address",
      },
    ],
    name: "Register",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usds",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "power",
        type: "uint256",
      },
    ],
    name: "Stake",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdtAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "UsdtPurchaseUsds",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usds",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsToBurn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "power",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ticketNumber",
        type: "uint256",
      },
    ],
    name: "WithdrawPromotionUsds",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lpUsdtPrice",
        type: "uint256",
      },
    ],
    name: "_lpToUsd",
    outputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stfUsdtPrice",
        type: "uint256",
      },
    ],
    name: "_usdToStf",
    outputs: [
      {
        internalType: "uint256",
        name: "stf",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdtStfLpAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "usdsStfLpPrice",
        type: "uint256",
      },
    ],
    name: "_usdsStfLpToUsd",
    outputs: [
      {
        internalType: "uint256",
        name: "usd",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "calcTotalReward",
    outputs: [
      {
        internalType: "uint256",
        name: "totalReward",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "newRewardRate",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "earned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "startTime_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endTime_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "rewardPerDay_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "rewardPerDayMin_",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "needClearRewardPerTotalSourceStored",
        type: "bool",
      },
    ],
    name: "forceSet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getReward",
    outputs: [
      {
        internalType: "uint256",
        name: "reward",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "bonus",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lastTimeRewardApplicable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "retE18",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "newRewardRate",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "usdsToPower",
    outputs: [
      {
        internalType: "uint256",
        name: "power",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "whenTimestamp",
        type: "uint256",
      },
    ],
    name: "whichDay",
    outputs: [
      {
        internalType: "uint256",
        name: "dayNumber",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "dayStartTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "dayFinishTimestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdsAmount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type ManagerLogic2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ManagerLogic2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ManagerLogic2__factory extends ContractFactory {
  constructor(...args: ManagerLogic2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ManagerLogic2> {
    return super.deploy(overrides || {}) as Promise<ManagerLogic2>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ManagerLogic2 {
    return super.attach(address) as ManagerLogic2;
  }
  override connect(signer: Signer): ManagerLogic2__factory {
    return super.connect(signer) as ManagerLogic2__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManagerLogic2Interface {
    return new utils.Interface(_abi) as ManagerLogic2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManagerLogic2 {
    return new Contract(address, _abi, signerOrProvider) as ManagerLogic2;
  }
}
